import ToolBase from '../basic';
import DEFINE from '../define';

export default class Triangle extends ToolBase {

    name = DEFINE.TOOLS.TRIANGLE;

    setting = null;
    triangle = null;
    isDown = null;
    origX = null;
    origY = null;

    constructor(parent) {
        super(parent);
    }

    recover(object) {
        object.set({
            hasBorders: false,
            controls: Object.assign(this.getBasicControls(), {
                mtr: this.getTouchRotateControl({
                    x: 0.5,
                    y: 0,
                    offsetX: 25,
                    offsetY: 0,
                }),
                deleteControl: this.getDeleteControl({
                    x: 0.5,
                    y: -0.5,
                    offsetX: 25,
                    offsetY: 0,
                }),
            })
        })
    }

    mouseUp(o) {
        this.isDown = false;

        this.parent.addHistory();
    }

    mouseDown(o) {
        this.setting = this.parent.getDrawSetting(DEFINE.DRAW_TYPE.SHAPE);

        this.isDown = true;
        let pointer = this.getLimitPointer(this.canvas.getPointer(o.e));
        this.origX = pointer.x;
        this.origY = pointer.y;
        this.triangle = new fabric.Triangle({
            tag: DEFINE.TAG.TRIANGLE + new Date().getTime(),
            toolType: this.name,
            left: this.origX,
            top: this.origY,
            originX: 'center',
            originY: 'top',
            width: 0,
            height: 0,
            angle: 0,
            flipY: false,
            opacity: this.setting.opacity,
            fill: this.setting.fill,
            stroke: this.setting.stroke,
            strokeWidth: this.setting.strokeWidth,
            cornerColor: DEFINE.COLOR.CORNER_COLOR,
            hasBorders: false,
            transparentCorners: false,
            selectable: true,
            perPixelTargetFind: true,
            paintFirst: "stroke",
            strokeUniform: true,
            controls: Object.assign(this.getBasicControls(), {
                mtr: this.getTouchRotateControl({
                    x: 0.5,
                    y: 0,
                    offsetX: 25,
                    offsetY: 0,
                }),
                deleteControl: this.getDeleteControl({
                    x: 0.5,
                    y: -0.5,
                    offsetX: 25,
                    offsetY: 0,
                }),
            })
        });

        this.canvas.add(this.triangle);

        if (o.target) {
            this.canvas.discardActiveObject(o.target);
        }
    }

    mouseMove(o) {
        if (!this.isDown) return;
        let pointer = this.getLimitPointer(this.canvas.getPointer(o.e));

        this.triangle.set({
            flipY: (this.origY > pointer.y) ? true : false,
            top: (this.origY > pointer.y) ? pointer.y : this.origY,
            width: Math.abs(this.origX - pointer.x) * 2,
            height: Math.abs(this.origY - pointer.y)
        });

        this.triangle.setCoords();
        this.canvas.renderAll();
    }
}